export default __webpack_public_path__ + "static/realWorldImage1-9f1a2eb8dec86356c9789cc87f59147e.webp";